import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { ZonesIcon, SettingsIcon } from 'components/Icons';

import "./Main.scss";

const MainMenu = () => {
  const location = useLocation();
  const { pathname } = location;

  let selectedKey = pathname;

  if (selectedKey.includes("settings")) {
    selectedKey = "/settings";
  } else if (selectedKey.includes("zones")) {
    selectedKey = "/zones";
  } else {
    selectedKey = "/index";
  }

  return (
    <Menu
      className="MainMenu"
      selectedKeys={[selectedKey]}
      mode="horizontal"
    >
      <Menu.Item key="/zones">
        <div className="MenuItemTop">
          <ZonesIcon />
        </div>
        <div className="MenuItemContent">
          <Link to="/zones">
            Zoner
          </Link>
        </div>
      </Menu.Item>
      <Menu.Item key="/settings">
        <div className="MenuItemTop">
          <SettingsIcon />
        </div>
        <div className="MenuItemContent">
          <Link to="/settings">
            Inställningar 
          </Link>
        </div>
      </Menu.Item>
    </Menu>
  );
};

export default MainMenu;
